import { useEffect } from 'react'
import { Loader2 } from 'lucide-react'

import { controllerWhatsappOficial } from '../../../services/controllers/service-activation'
import { useWhatsappOficial } from '../../../store/service-activation/useWhatsappOficial'
import { useMerchant } from '../../../store/global/useMerchant'

import { Connect } from './connect'
import { Account } from './account'
import { Usage } from './usage'

export function WhatsappOficial() {
  const merchant = useMerchant((st) => st.data.merchant)

  const loading = useWhatsappOficial((st) => st.data.loading)
  const account = useWhatsappOficial((st) => st.data.account)
  const usage = useWhatsappOficial((st) => st.data.usage)

  const controller = controllerWhatsappOficial()

  useEffect(() => {
    controller.loadStatus()
    return () => controller.stopWatching()
  }, [merchant])

  useEffect(() => {
    if (account.status === 'active') controller.loadUsage()
    if (account.status === 'syncing') controller.watchStatus()
  }, [account.status])

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-gray-500 py-10">
        <Loader2 className="w-4 h-4 animate-spin" />
        Carregando...
      </div>
    )
  }

  const conectado = ['syncing', 'active', 'suspended'].includes(account.status)

  return (
    <div className="flex flex-col gap-8 w-full py-4">
      {conectado ? (
        <>
          <Account account={account} onRetrySync={controller.retrySync} />
          {account.status === 'active' && <Usage usage={usage} />}
        </>
      ) : (
        <Connect
          status={account.status}
          error={account.error}
          onConnect={controller.connect}
        />
      )}
    </div>
  )
}
